export default {"src":"/_next/static/media/contentsOutline75_40.a15b52a7.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};